<template>
  <JoinPage class="join-page" />
</template>

<script>
import JoinPage from '@/scripts/pages/join/index.ts.vue';

export default {
  components: {
    JoinPage,
  },
};
</script>

<style lang="scss">
body > .banner.clearfix.hidden-sm-up {
  display: none;
}
</style>

<style lang="scss">
.join-page {
  @import '~@/scripts/pages/onepager/styles/entry';

  font-size: 16px;
  line-height: 1.5;
  color: #212529;

  .flex-center {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .btn {
    font-weight: bold;
  }
}
</style>
